import { render, staticRenderFns } from "./FormTemplatePage.vue?vue&type=template&id=004efe22&"
import script from "./FormTemplatePage.vue?vue&type=script&lang=js&"
export * from "./FormTemplatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports